/**
 * @file: context.tsx
 *
 * The inbox context — central coordination state for the inbox surface.
 * Provided by `InboxProvider`; consumed via `useInboxContext`.
 */

import { createContext, useContext } from 'react';
import { InboxContextProps } from './types';

export const InboxContext = createContext<InboxContextProps>(null as any);

export const useInboxContext = () => useContext(InboxContext);
